export default __webpack_public_path__ + "static/media/plant2.8c08fab4.png";